<template>
  <div class="character" :class="{ talking, laughing, walking }">
    <img class="base" src="img/logo.png">
    <img class="eyes" src="img/eyes.png">
    <img class="moustache" src="img/moustache.png">
  </div>
</template>

<script>
export default {
  name: 'SpectralSite',
  props: ['talking', 'laughing', 'walking']
}
</script>

<style lang="scss">
.character {
  position: relative;
  z-index: 2;
  width: 250px;

  > img {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
  }

  &.talking {
    .moustache {
      animation: talking 0.6s infinite;
    }
  }

  &.laughing {
    .eyes {
      animation: laughing 0.3s infinite;
    }

    .moustache {
      animation: laughing 0.3s infinite;
    }
  }

  &.walking {
    animation: walking 0.8s infinite;
  }
}

@keyframes talking {
  0% {
    transform: rotate(1deg);
  }
  20% {
    transform: rotate(-1deg);
  }
  40% {
    transform: rotate(1.5deg);
  }
  50% {
    transform: rotate(0deg);
  }
  55% {
    transform: rotate(0.5deg);
  }
  60% {
    transform: rotate(1.5deg);
  }
  80% {
    transform: rotate(-1deg);
  }
}

@keyframes laughing {
  0% {
    transform: translate(0, 0px);
  }
  50% {
    transform: translate(0, 10px)
  }
  100% {
    transform: translate(0, 0px);
  }
}

@keyframes walking {
  0% {
    transform: rotate3d(0, 1, 0, 20deg);
  }
  50% {
    transform: rotate3d(0, 1, 0, -20deg);
  }
  100% {
    transform: rotate3d(0, 1, 0, 20deg);
  }
}
</style>
